import { useQueryFetch } from 'sonata-react-components';
import { getInsertionOrderState, getLineItemStatus } from 'sonata-static-storage/lib/entities';

import { useGlobalStore } from '@/store/global';
import { getSessionByKeys } from '@/store/global/session/selectors';

import type { MultiFlightEntityState } from 'sonata-static-storage/lib/common/common.types';
import type { DoohAudienceEntity } from '@/services/doohAudience.service';

/**
 * Whether the insertion order / line item is in any of the given states, by the state its SubHeader shows (same query,
 * so the same request): its stored status is only recalculated when that state is read. False without id.
 */
export function useIsEntityInState(
  entity: DoohAudienceEntity,
  id: string | undefined,
  states: MultiFlightEntityState[]
): boolean {
  const { user: userId = '' } = useGlobalStore(store => getSessionByKeys(store, ['user']));
  const { data } = useQueryFetch<{ state?: unknown }>(
    [`get${entity}State`, userId, id],
    () => (entity === 'insertionOrder' ? getInsertionOrderState(userId, id!) : getLineItemStatus(id!)),
    { enabled: Boolean(id), staleTime: 0 }
  );

  return ([] as MultiFlightEntityState[]).concat(states).some(state => state === data?.state);
}
